/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import LabelToggle from './LabelToggle';
import generateDropdown from '../generateDropdown';

export default generateDropdown(LabelToggle);
